import React from 'react'
import DarkMode from '../../../components/Authentication/DarkMode'
import SignInForm from '../../../components/Authentication/SignInForm'

const SignIn: React.FC = () => {
  return (
    <>
      <DarkMode />
      <SignInForm />
    </>
  )
}

export default SignIn

